import navLayoutRaw from "../../../production/contracts/i0/first-yard-nav-v1.json?raw";
import purchaseBoxManifestRaw from "../../../assets/art/manifests/first-yard/first-yard-purchase-box-proxy.v1.json?raw";
import workSphereManifestRaw from "../../../assets/art/manifests/first-yard/first-yard-work-sphere-proxy.v1.json?raw";
import { canonicalManifestJson, validateFarmAssetManifest } from "../../assets/index.ts";
import { validateNavLayout } from "../../navigation/base/index.ts";
import { createInstalledManualChainS04Port } from "./s04-port.ts";
import type { InstalledManualChainS04Options, InstalledManualChainS04Result } from "./types.ts";

const encoder = new TextEncoder();

async function sha256Bytes(bytes: Uint8Array): Promise<string> {
  const copy = new Uint8Array(bytes);
  const digest = await globalThis.crypto.subtle.digest("SHA-256", copy.buffer);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function firstYardManualChainInstallOptions(): InstalledManualChainS04Options {
  return Object.freeze({
    dependencies: Object.freeze({
      validateD017Manifest: validateFarmAssetManifest,
      canonicalizeD017Manifest: canonicalManifestJson,
      sha256Bytes,
      validateNavLayout,
    }),
    installBatch: Object.freeze({
      navLayoutUtf8Bytes: encoder.encode(navLayoutRaw),
      manifestSources: Object.freeze([
        Object.freeze({ sourceIndex: 1, canonicalManifestUtf8Bytes: encoder.encode(workSphereManifestRaw) }),
        Object.freeze({ sourceIndex: 2, canonicalManifestUtf8Bytes: encoder.encode(purchaseBoxManifestRaw) }),
      ]),
      entries: Object.freeze([1, 1, 1, 2, 2, 2, 2].map((sourceIndex) => Object.freeze({ sourceIndex }))),
    }),
  });
}

export function createFirstYardManualChainS04Port(): Promise<InstalledManualChainS04Result> {
  return createInstalledManualChainS04Port(firstYardManualChainInstallOptions());
}
